import React from 'react';
import { useSelector } from 'react-redux';
import { CssBaseline, ThemeProvider } from '@mui/material';
import { getThemeSelector } from '@store/theme/theme.selectors';
import { Theme } from '@enums';
import { darkTheme, lightTheme } from '@themes';
import { AppGlobalStyles } from '@themes/global-styles.component';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var WithTheme = function WithTheme(_ref) {
  var children = _ref.children;
  var theme = useSelector(getThemeSelector);
  return /*#__PURE__*/_jsxs(ThemeProvider, {
    theme: theme === Theme.Light ? lightTheme : darkTheme,
    children: [/*#__PURE__*/_jsx(CssBaseline, {}), /*#__PURE__*/_jsx(AppGlobalStyles, {}), children]
  });
};

export { WithTheme };